import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button,Table } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';


function Phd_AdmissionELe() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    const [categoryOpen, setCategoryOpen] = useState(false);    
    const [areasOpen, setAreasOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);
    
    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        setCategoryOpen(false);
        setAreasOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                {/* <> */}
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Admissionleft activeIndex={0} />
                    </Col>

                    <Col md={8} className='c-right'>

                        <div className="c-heading">
                            <h3>Ph.D.</h3> <br />
                        </div>
                        
                        <Row className='mb-5'>
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button'
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}>
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setGuidelinesOpen)}
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}>
                                    Guidelines
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}>
                                    Categories
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}>
                                    Areas
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setEligiblityOpen)}
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}>
                                    Eligiblity
                                </Button>
                            </Col>

                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setFinancialOpen)}
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}>
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}>
                                    Selection
                                </Button>
                            </Col>
                            {/* Documents */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setDocumentsOpen)}
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}>
                                    Documents
                                </Button>
                            </Col>

                            {/* Fees */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}>
                                    Fees
                                </Button>
                            </Col>

                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setApplyonlineOpen)}
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}>
                                    Apply Online
                                </Button>
                            </Col>

                            

                        </Row>
                        <p><b className="glowing-text"> <Link className="c-link" to="/msphd-admissions" target='_blank'>List of provisionally shortlisted candidates for Written Test/Interview - M.S(R) & Ph.D - September 2024 Notification. - Click here</Link></b> </p>

                        {/*dates */}
                    <div>
                        {datesOpen && <Fade in={datesOpen}>
                            <div>
                                 
                            {/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for Ph.D. Scholars on July 25-26, 2024 - {" "}
                            <Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_MS_PhD_Jul_24.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p> */}

                                 {/* <span> 
                                    <img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" />
                                    <Link className='text-maroon' href="https://files.iittp.ac.in/pdfs/admissions/2024/MS_PhD_July_2024_Flyer.pdf" target="_blank;" className='c-link'><b>Ph.D. Admissions for July-2024 Brochure - Click here</b></Link>
                                 </span> */}

                                <Table bordered responsive className='mt-3'>
                                    <thead>
                                        <tr>
                                            <th colSpan="2" className="text-center">
                                                <h4 className="text-primary">Important Dates</h4>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Opening date and time for online application</td>
                                                <td><b>Friday, 20th September 2024, at 10 AM</b></td>
                                        </tr>
                                        <tr>
                                            <td>Closing date and time for online application</td>
                                            <td><b>                                         
                                            <s>Monday, 14th October</s> Thursday, 17th October 2024, until 5 PM</b></td>
                                        </tr>
                                        <tr>
                                            <td>Written Test / Interview</td>
                                                <td><b>	5th November 2024 to 18th November 2024 </b></td>
                                        </tr>
                                        <tr>
                                            <td>Announcement of Results</td>
                                                <td><b>	Within one week from the completion of the interview</b></td>
                                        </tr>
                                        <tr>
                                            <td>Reporting to Campus</td>
                                                <td><b>Monday, 2nd December 2024</b></td>
                                        </tr>
                                        <tr>
                                            <td>Date of Orientation Program</td>
                                            <td><b>Will be updated soon...</b></td>
                                                {/* <td><b>	Tuesday, 3rd December 2024</b></td> */}
                                        </tr>

                                        {/* <tr>
                                            <td>Commencement of classes</td>
                                            <td><b>Thursday, August 1, 2024</b></td>
                                        </tr> */}

                                    </tbody>
                                </Table>
                                    
                                    <b>Please write to <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link>  for any questions or queries regarding admission related matters. </b>
                            </div>
                        </Fade>
                    }
                    </div>


                        {/*Guidelines*/}
                        
                    <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='c-lineheight2dot5'>
                                  
                                        <h4 className="mb-3">Important Guidelines for Ph.D. Application</h4>
                                    <ol className="list-group list-group-numbered"
                                        
                                        style={{ textAlign: 'justify', fontSize: '12pt' }}>
                                            <li>
                                            The link to the online application form is available in the Apply Online tab. After filling out the form, please take a print and keep it for your record.
                                            </li>
                                            <li>
                                                The application fee is as follows:
                                            <ul className='myulcustarrow'>
                                                    <li>
                                                     GEN/EWS/OBC-NCL Male candidates: Rs.400/-
                                                    </li>
                                                    <li>
                                                         GEN/EWS/OBC-NCL Female candidates: Rs.200/-
                                                    </li>
                                                    <li>
                                                     SC/ST and PwD candidates: Rs.200/-
                                                    </li>
                                                </ul>
                                                <p style={{ color: '#2009df' }}>The application fee is non-refundable. Please ensure to save the payment reference number.</p>
                                            </li>
                                            <li>
                                            A candidate can apply to more than one division among all departments; however, the maximum number of divisions to which he or she can apply is three.
                                            </li>
                                            <li>
                                            Candidates called for the written test/interview must produce a copy of the application submitted online along with originals and photocopies of the relevant certificates.
                                            </li>
                                            <li>
                                            Reservation/concession/relaxations for EWS/OBC-NCL/SC/ST/PwD and Kashmiri- Migrants (KM), including Kashmiri Pandits/Kashmiri Hindu Families: As per the Government of India rules. A copy of a valid OBC-NCL/ST/SC/EWS/PwD certificate must be uploaded during the ONLINE application and must be submitted at the time of admission.
                                            </li>
                                            <li>
                                            A Statement of Purpose (SoP) must be uploaded along with the online application. The guidelines for preparing the SoP are available at this <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/1.docx" target="_blank" rel="noopener noreferrer">Link</Link>.
                                            </li>
                                            <li>
                                            At the time of physical reporting to the Institute, candidates must submit self-attested copies of the relevant certificates as specified in the Documents tab, failing which admission will stand cancelled.
                                            </li>
                                            <li>
                                            Please make all files ready with following format and size before going to file upload: 
                                            <ul className='myulcustarrow'>
                                                    <li> Passport size Photo (jpg, jpeg, png), size &lt;=500 KB</li>
                                                    <li> Signature (format jpg, jpeg, png) size &lt;= 200 KB</li>    
                                                    <li> 10th Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> 12th / Diploma / Equivalent Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> Qualifying UG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> Consolidated UG mark sheet (pdf) size &lt;=1024 KB</li>
                                                    <li> Qualifying PG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> Consolidated PG mark sheet (pdf) size &lt;=1024 KB</li>
                                                    <li> Community Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                    <li> PwD Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                    <li> Applicable National Level Exams/GATE (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                                    <li> SoP/Research Proposal, (pdf) size &lt;=1024 KB</li>
                                                    <li> First page of publication, if applicable (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                                </ul>
                                                <p><b>Additional documents for external/part-time/internal category candidates</b></p>
                                                <ul className='myulcustarrow'>
                                                    <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                    <li> No-Objection Certificate or Undertaking 
                                                        <ul className='myulcustarrow'>
                                                         <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                         </ul>
                                                         </li>
                                                </ul>
                                            </li>
                                            <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>
                                            <li>
                                            Please visit the institute’s website regularly for important announcements and results.
                                            </li>
                                            <li>
                                                In case of any queries, please write to{' '}
                                            <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link> or call 0877 250 3531 (9.00 AM to 5.30 PM on all working days).
                                            </li>
                                        </ol>
                                  
                            </div>
                        </Fade>
                    }
                </div>


                        {/*Categoies*/}

                        <div>
                        {categoryOpen && <Fade in={categoryOpen}>
                                <div className='c-lineheight2dot5'>

                                    <h4 className="mb-3">Ph.D. admissions are made under various modes of HTRA (Half Time Research Assistantship) and Non-HTRA categories as mentioned below:</h4>
                                    <h5 className='me-3 mt-3'>HTRA Category: </h5>
                                    <ul className="">
                                        <li>
                                        <b>  1. Regular (Full-time scholars): </b> The research scholars selected under regular registration will be eligible for assistantship through various schemes (please see Financial Assistance)
                                        </li>
                                    </ul>
                                    <h5 className='me-3 mt-3'>Non-HTRA Category:</h5>
                                    <ul className="">
                                        <li>
                                        <b>  1. External: </b>
                                            <ul className='myulcustarrow'>

                                         
                                                    <li> The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                                    <li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST or by IIT Tirupati.</li>
                                                    <li> Research scholars admitted under this category will normally carry out part or all of their research in the parent organization under supervision of a faculty from IIT Tirupati and a co-supervisor employed in their parent organization.</li>

                                                    <li> The following documents are required along with the application
                                                    <ul className='myulcustarrow'>
                                                    <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                    <li> No-Objection Certificate or Undertaking 
                                                        <ul className='myulcustarrow'>
                                                         <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                         </ul>
                                                         </li>
                                                </ul>
                                                        
                                                    </li>

                                                    <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow'>
                                                        <li>Certificate of Support from the Employer</li>
                                                        <li>Relieving Certificate from the Employer: <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;" className='c-link'>Link</Link></li>
                                                        </ul>
                                                    </li>
                                        
                                            </ul>  
                                        </li>   
                                    </ul>
                                    <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

                                    <ul>
                                        <li>
                                            <b>  2. Part-Time: </b>

                                            <ul className='myulcustarrow'>
                                                <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                                <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>


                                                <li> The following documents are required at the time of application
                                                <ul className='myulcustarrow'>
                                                    <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                    <li> No-Objection Certificate or Undertaking 
                                                    <ul className='myulcustarrow'>
                                                         <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                         </ul>
                                                         </li>
                                                </ul>
                                                </li>
                                                <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow'>
                                                        <li>Relieving (Leave) Certificate from the Employer: <a href="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;" className='c-link'>Link</a></li>
                                                    </ul>
                                                </li>
                                            </ul>

                                        </li>
                                    </ul>
                                    <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

                                    <ul>
                                        <li>
                                            <b>  3. Internal (IIT Tirupati Staff): </b>

                                            <ul className='myulcustarrow'>
                                                <li> The applicant must be regular employees of IIT Tirupati.</li>
                                                <li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                                <li><b>Candidate must produce NoC at the time of Written Test / Interview</b></li>
                                            </ul>
                                        </li>
                                    </ul>

                                   
                                    <ul>
                                        <li>
                                            <b> Note: </b>

                                            <ul className='myulcustarrow'>
                                                <li> The minimum residential requirement for the Ph.D. research scholars under External/Part-time category of admission is one semester.</li>
                                                <li> Candidates admitted under Non-HTRA category cannot be moved to HTRA category at a later date.</li>
                                                <li> More details on External/Part-time category of admission, including any questions regarding the recognition of the organization/laboratory might be addressed to the Head of the department of interest or <Link className='c-link' to="mailto:admissions@iittp.ac.in">admissions@iittp.ac.in</Link> </li>
                                            </ul>
                                        </li>
                                    </ul>


                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Areas*/}

                        <div>
                            {areasOpen && <Fade in={areasOpen}>
                        <div>
                            <h4 className='mb-4'>Research Areas</h4>
                            <p>
                            Applicants are required to select the research areas in the online admission portal as per the availability in the respective category/scheme. The available research areas for September 2024 admission notification are tabulated below.</p>
                                   <p> <b>SoP is mandatory for Chemical Engineering, Civil and Environmental Engineering, Computer Science and Engineering,  Chemistry, Electrical Engineering, Mechanical Engineening, Chemistry,  Physics. <a className='c-link' href="https://files.iittp.ac.in/pdfs/msphd/admissions/SoP.pdf" target="_blank">Click here for SoP template</a></b>
                            </p>

                                    {/* Table */}
                                    <Table bordered responsive className='mt-3 c-table'>
                                        <colgroup>
                                            <col style={{ width: '20%' }} /> {/* 33% for each column */}
                                            <col style={{ width: '20%' }} />
                                            <col style={{ width: '30%' }} />
											 <col style={{ width: '30%' }} />
                                        </colgroup>
                                        <tbody>
                                            {/* Table header */}
                                            <tr>
                                                <td><b>Department</b></td>
                                                <td><b>Division</b></td>
                                                <td><b>Areas of Research</b></td>
												<td><b>Additional Information</b></td>
                                            </tr>
                                            {/* Table rows */}
                                            {/* Row 1 */}
                                            <tr>
                                                <td>Chemical Engineering</td>
                                                <td>Chemical Engineering</td>
                                                <td>General Chemical Engineering, Process Control and Optimization, Machine Learning in Chemical Engineering, Oil and gas supply chain management, Production and distribution optimization, Water Distribution and Management, Optimization based process synthesis, Artificial Intelligence-driven Process Modelling and Monitoring, Computational Fluid Dynamics, Desalination, Fluid and Particle Mechanics, Granular Flow, Liquid-Liquid Extraction, Material Synthesis with Microreactors, Battery recycling, Computationally engineered nanomaterials, Corrosion Studies, Hybrid super capacitors, Materials for Gas Separation, Molecular simulations, Solid state battery, Biomass to Chemicals, Soft matter and food colloids</td>
												<td> </td>
											</tr>

                                            {/* Row 6 */}
                                            <tr>
                                                <td rowspan="5" className='c-table-rowspan-align'>Chemistry</td>
                                                <td>Physical Chemistry</td>
                                                <td>Quantum Chemistry Based Modelling Studies: Theory and Applications, Computational Chemistry and Soft-Matter: Small Molecules, Materials, Proteins, and Machine Learning, Information Engine, Stochastic Thermodynamics, Fluorescence spectroscopy and microscopy, Biophysical chemistry</td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>Theoretical Chemistry</td>
                                                <td>Quantum Chemistry, Modelling Light-Matter Interactions </td>
                                                <td> </td>
                                            </tr>
                                           

                                            <tr>
                                                <td>Organic Chemistry</td>
                                                <td>Total synthesis of biologically active oligosaccharides and synthesis of drug intermediates, Organic Synthesis: C-H Activation, Photo- and Electro Organic Synthesis, Transition Metal Catalysis, Asymmetric Total synthesis of Bioactive Natural Products and Drug Intermediates, Catalytic Asymmetric Cross-Coupling Reactions, 3d-Transition Metal Catalysis, and Photoredox Catalysis</td>
                                                <td> </td>
                                            </tr>

                                            <tr>
                                                <td>Inorganic Chemistry</td>
                                                <td>Supramolecular chemistry and Polyoxometalates, Synthetic inorganic and bioinspired inorganic chemistry of transition metals</td>
                                                <td> </td>
                                            </tr>

                                            <tr>
                                                <td>Medicinal Chemistry</td>
                                                <td>Medicinal Chemistry, Chemical Biology and Anticancer Drug Discovery</td>
                                                <td> </td>
                                            </tr>

                                            {/* Row 2 */}
                                            <tr>
                                                <td rowSpan="7" >
                                                    Civil and Environmental
                                                    Engineering
                                                </td>

                                                <td>
                                                    Environmental Engineering
                                                </td>
                                                <td>
                                                    Air Pollution and Health, Capacitive Deionization, Advanced Water and Wastewater Treatment, Wastewater Treatment and Management
                                                </td>
                                                <td> </td>
                                            </tr>

                                            <tr>

                                                <td>
                                                    Geoinformatics  
                                                </td>
                                                <td>
                                                    Remote Sensing, Geoid Modeling
                                                </td>

                                                <td> </td>
                                            </tr>

                                            <tr>

                                                <td>
                                                    Geotechnical Engineering
                                                </td>
                                                <td>
                                                    Ground improvement and Geosynthetics
                                                </td>
                                                <td> </td>

                                            </tr>

                                            <tr>
                                                <td>
                                                    Structural Engineering
                                                </td>
                                                <td>Structural steel design, Concrete Structures, Special concretes, Supplementary cementitious materials for concrete, Structural Fire Engineering, Durability of concrete structures, Structural health monitoring</td>
                                                <td> </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Transportation Engineering
                                                </td>
                                                <td>
                                                    Transportation Engineering
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Water Resources Engineering
                                                </td>
                                                <td>
                                                    Water Resources Engineering
                                                </td>
                                                <td> </td>
                                            </tr>
											
											 <tr>
                                                <td>
                                                    Interdisciplinary - Civil and Environmental Engineering
                                                </td>
                                                <td>
                                                    Sustainability and Life Cycle Analysis, Climate Change Mitigation, Adaptation and Resilience, Nanotechnology Enabled Water Treatment, Statistical Downscaling - Global Climate Model, Flood Modelling, Natural Fiber Composites
                                                </td>
                                                <td> </td>
                                            </tr>


                                            {/* Row 3 */}
                                            <tr>
                                                <td>
                                                    Computer Science and
                                                    Engineering
                                                </td>
                                                <td>
                                                   Computer Science and Engineering
                                                </td>
                                                <td>
                                                Parallel Computing, High Performance Computing, Quantum System Architecture, ML for IoTs, Computer Networks, Algorithms and Data Structures, Generative AI, Generative AI and Software Engineering, Responsible Computing for Society, Cyber Security and AI, Reinforcement Learning, Deep Learning and Emergent Communication, Multi Agent Systems, Algorithms and Complexity, Computer Vision, Deep Learning for Autonomous Objects (Drones & Vehicles), Processor Design, VLSI Design and Test, Dependable AI Accelerator, Human-Computer Interaction
                                                </td>
                                                <td> </td>
                                            </tr>
                                           

                                            {/* Row 4 */}
                                            <tr>
                                                <td rowSpan="6" >
                                                    Electrical Engineering
                                                </td>

                                                <td>Power and Control</td>
                                                <td>
                                                Power Electronics, Control and Robotics, Power Systems and Smart Grids 
                                                </td>
                                                <td> </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Semiconductor Devices
                                                </td>
                                                <td>
                                                Semiconductor Devices
                                                </td>
                                                <td> </td>
                                            </tr>

                                            <tr>
                                                <td>VLSI and Embedded Systems</td>
                                                <td>Sensors and Embedded Hardware Design, VLSI Design (Processor Design and Hardware Security)</td>
                                                <td>Candidates with background in Electronics and Communication Engineering/ Electrical Engineering/ Instrumentation Engineering/ Computer Science and Engineering  are encouraged to apply </td>
                                            </tr>
											
											 <tr>
                                                <td>
                                                    Signal Processing & Machine Learning
                                                </td>
                                                <td>
                                                Deep Learning for Medical Imaging, Deep Learning for Computer Vision
                                                </td>
                                                <td>Candidates with background in 
Electrical Engineering/ Electronics and Communication Engineering/ Computer Science and Information Technology/ Data Science and Artificial Intelligence 
are encouraged to apply </td>
                                            </tr>
                                      
                                            <tr>
                                                <td>
                                                    RF & Microwave
                                                </td>
                                                <td>
                                                Advanced Antenna Systems and Base Station ,RF and Microwave Components, Metamaterials and RF Sensing
                                                </td>
                                                <td> For the PhD program in the RF & Microwave stream, eligible applicants include those with a valid GATE score in EE, EC, PH OR valid UGC/CSIR-NET score in Electronic Science.</td>
                                            </tr>
											
											 <tr>
                                                <td>
                                                    Next-Generation Wireless Communications and Networks
                                                </td>
                                                <td>
                                                Communication Networks for 6G and Beyond, Machine learning for Wireless Communication
                                                </td>
                                                <td> </td>
                                            </tr>
											
											


                                            {/* Row 9 */}
                                            <tr>
                                                <td rowSpan="3" >Humanities and Social Sciences</td>
                                            
                                            
                                                <td>Organizational Behavior/HRM</td>
                                                <td>
                                                Sustainable HRM, Decent Work and positive work outcomes, Positive Organizational Behavior, Strategic HRM and Organizational Performance, Academic Leadership
                                                </td>
                                                <td> </td>
                                            </tr>

                                            <tr>
                                                <td>Economics</td>
                                                <td>
                                                Financial Economics, Macroeconomics, Political Economy of Development, Development Economics, Environmental Economics, Economics of Disaster and Climate Change, Energy Economics</td>
                                                <td> </td>
                                            </tr>

                                            <tr>
                                                <td>Operations Management/Industrial Engineering</td>
                                                <td>
                                                Supply Chain Management, Reliability Engineering and Maintenance Management, Production Planning and Control, Project Management, Applications of Operations Research, Statistics and Machine Learning in Operations Management
                                                </td>
                                                <td> </td>
                                            </tr>
                                          


                                            {/* Row 8 */}
                                            <tr>
                                                <td rowspan="2" className='c-table-rowspan-align'>Mathematics and Statistics</td>
                                                <td>Mathematics</td>
                                                <td>	
                                                Real Analysis, Complex Analysis, Functional Analysis, Numerical Analysis, Partial Differential Equations, Inverse Problems, Computational Fluid Dynamics
                                                </td>
                                                <td> </td>
                                            </tr>
                                            <tr>
                                                <td>Statistics</td>
                                                <td>Non-parametric Statistics, Multivariate Statistics, Biostatistics, Geospatial Statistics, Time Series Analysis, Machine Learning, Reliability and Survival Analysis, Causal Inference, Spatial-Temporal Models, Generalized Linear Models, Financial Time Series</td>
                                                <td> </td>
                                            </tr>



                                            {/* Row 5 */}
                                            <tr>
                                                <td rowspan="5" valign="middle">Mechanical Engineering</td>
                                                <td>Advance Manufacturing</td>
                                                <td>Industrial robotics, Automated inspection, Human-robot interaction simulation, Machining, Digital twin for the hybrid twin wire arc additive manufacturing process, Biotechnology, Hybrid wire arc additive manufacturing of Ti6Al4V defence products, AI infused defect detection in metal additive manufacturing, Polymer Science and Engineering,  Hydrogels, Composites 3D Printing.</td>
                                                <td valign="middle">Candidates from Electrical/ Electronics/ Mechanical/ Computer science/ Mechatronics/ Instrumentation backgrounds are encouraged to apply</td>
                                            </tr>
                                            <tr>
                                                <td rowSpan="2">Fluids and Thermal Engineering</td>
                                                <td>Droplet and Spray Dynamics, Theoretical fluid mechanics, wave hydrodynamics, mathematical modeling of fluid flow CFD, High speed combustion modeling, Experimental fluid mechanics, CFD, aerodynamics of drones and wind turbines</td>
                                            <td></td>
                                            </tr>
                                            <tr>
                                            <td>Hydrogen and Energy storage, Combustion, Thermal management in batteries </td>
                                            <td>Candidates with background in  Mechanical/ Chemical / Energy science/Production backgrounds are encouraged to apply</td>
                                            </tr>
                                            <tr>
                                                <td>Robotics and Mechatronics</td>
                                                <td>Design and Control of Underwater Robots, Digital Twins for a fleet of Underwater Robots, Robots for Construction Automation and 3D Printing of Concrete Structures, Cooperative Field Robots, Mechatronic Systems for Road Quality Assessment, Robots for Food Processing and preservation, Control of Autonomous Systems</td>
                                                <td valign="middle">Candidates with background in Electrical/ Electronics/ Mechanical/ Computer science/ Mechatronics/ Instrumentation are encouraged to apply</td>
                                            </tr>
                                            <tr>
                                                <td>Solid Mechanics and Design</td>
                                                <td>Vehicle Dynamics, Automotive NVH, Fault detection, Digital twin for health monitoring, Experimental and theoretical biomechanics, Physics informed machine learning, Nonlinear solid mechanics, Plasticity, Phase transformations, Computational Solid Mechanics, Composite Materials, Machine learning in Mechanics, Auxetic Materials</td>
                                                <td valign="middle">Candidates with background in Civil Engineering with a PG degree in Structural engineering, Computational or Applied Mechanics are also encouraged to apply</td>
                                            </tr>

                                           
                                        
                                            {/* Row 7 */}
                                            <tr>
                                                <td rowSpan="4" >Physics</td>
                                           
                                                <td rowSpan="2">Theoretical Physics</td>
                                                <td valign="middle">
                                                    Condensed matter theory
                                                </td>
                                                <td>This research area is available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF. </td>
                                                </tr>
                                                <tr>
                                                    <td>Ultrafast quantum dynamics</td>
                                                    <td>    
                                                    </td>

                                            </tr>
                                            
                                            <tr>
                                                <td rowSpan="2">Experimental Physics</td>
                                            
                                                    <td>
                                                    
                                                    Experimental nonthermal Plasma Physics for Environmental remediation research
                                                    </td>
                                            <td>This research area is available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.</td>
                                                </tr>
                                                <tr>
                                                <td>Experimental atomic physics and experimental quantum optics for cold atom-based research in quantum communication and quantum memories </td>                                           
                                                <td> This research area is available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.    
                                                    </td>
                                            </tr>
                                        

                                         


                                            {/* End of table rows */}
                                        </tbody>
                                    </Table>

                                {/* <p className='fw-bold text-info'><em>*These research areas available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.</em></p> */}
                                </div>
                            </Fade>
                            }
                        </div>



                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && <Fade in={eligiblityOpen}>
                                <div>
                                    <h4 className='mb-4'>Eligibility</h4>
                                    <p>Candidates seeking admission to the Ph.D. program in different disciplines are required to meet the minimum eligibility criteria regarding their educational qualifications and any additional qualifying exams, as outlined in the following table:</p>
                                    <Table bordered responsive className='mt-3 c-table' >
                                        <tbody>
                                           {/* <tr>
                                                <td colSpan="4">
                                                 <b>Minimum Qualifications for Admission to the Regular Ph.D program</b>
                                                    Candidates applying for the Ph.D program in one of the following areas need to have any one of the minimum qualifications mentioned in the table below:
                                                </td>
                        </tr> */}
                                            <tr>
                                                <td rowSpan="2">
                                                    <b>
                                                    Discipline
                                                    </b>
                                                </td>
                                                <td colSpan="3" >
                                                    <b>
                                                        Minimum Qualifications
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="65" >
                                                    <b>
                                                        S. No.
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        Educational Qualifications
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        Additional Qualifying Exam
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td rowSpan="5" height="422" valign="middle">
                                                    <b>
                                                        Engineering
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        1
                                                    </b>
                                                </td>
                                                <td >

                                                    • M.E / M.Tech / M.S by Research in Engineering / 5-year integrated Masters/Dual Degree in engineering.<br />
(or)<br />
                                                    • 2 year M.Sc from IITs (entry through JAM) with a minimum CGPA of 8 on a 10 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD) <br />(or) <br />
                                                    • B.S+M.S (5-year integrated) from CFTI

                                                </td>
                                                <td >
                                                    None
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        2
                                                    </b>
                                                </td>
                                                <td >
                                                    • M.Sc degree holders in the relevant discipline from any recognized university/institute are eligible.
                                                </td>
                                                <td >

                                                Valid GATE score/ UGC- NET/CSIR-NET/NBHM/ Inspire or equivalent qualification tenable for the year of registration. In case of candidates with more than 5 years relevant experience after the M.Sc, the requirement of a test score may be waived by the selection committee.

                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        3<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                B.S/B.E/B.Tech from a Centrally Funded Technical Institute (CFTI) with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                                </td>
                                                <td >
                                                    None
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        4<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                B.S/B.E/B.Tech from a CFTI without minimum CGPA 8.0 on a 10.0 point scale(7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                                </td>
                                                <td >
                                                    Valid GATE score
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        5<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                BE/BTech from any other university, with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                                </td>
                                                <td >
                                                    Valid GATE score
                                                </td>
                                            </tr>
                                            <tr>
                                                <td rowSpan="5" valign="middle">
                                                    <b>
                                                        Sciences
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        6
                                                    </b>
                                                </td>
                                                <td >

                                                    • M.E/M.Tech or M.S by Research in engineering <br />(or)<br />
                                                    • 2 year M.Sc from IITs (entry through JAM) with a minimum CGPA of 8.0 on 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD) <br />(or)<br />
                                                    • B.S+M.S, or 5-year integrated degree from CFTI

                                                </td>
                                                <td >
                                                    None
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        7
                                                    </b>
                                                </td>
                                                <td >

                                                    • M.Sc from IITs without minimum CGPA 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)<br />(or)<br />
                                                    • M.Sc from institutions other than IITS

                                                </td>
                                                <td >

                                                Valid GATE score or UGC-NET/CSIR-NET/NBHM/INSPIRE/JEST or equivalent qualification, tenable for the current year in the relevant area.

                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        8<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                    B.S/B.E/B.Tech from a Centrally Funded Technical Institute (CFTI) with a minimum CGPA of 8 on 10 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD).
                                                </td>
                                                <td >
                                                    None
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        9<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                    B.S/B.E/B.Tech from a CFTI without minimum CGPA 8 on a 10 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD).
                                                </td>
                                                <td >
                                                    Valid GATE score
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        10<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                    B.E/BTech from any other university, with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                                </td>
                                                <td >
                                                    Valid GATE score
                                                </td>
                                            </tr>
                                            <tr>
                                                <td rowSpan="1" valign="middle">
                                                    <b>
                                                        Humanities and Social Sciences
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        11
                                                    </b>
                                                </td>
                                                <td >
                                                    Master’s degree/dual-degree or equivalent in a relevant discipline
                                                </td>
                                                <td >

                                                Qualifying UGC-NET/CSIR-NET/ GATE score or equivalent qualification, tenable for the current year in the relevant area or an international-level post graduate admission examination such as GRE.<br /><br />Candidates with only a GRE (or equivalent international-level post graduate admission examination) score are not eligible for HTRA.

                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="4" >
                                                    # Candidates with Educational Qualifications as mentioned in the S.No. 3,4,5,8,9,10 will be considered for Direct Ph.D.

                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="4" >
                                                    Note: A valid GATE score or UGC/CSIR-NET/INSPIRE/NBHM qualification etc. is not required in the case of candidates applying under the external/part-time/internal staff category. 
                                                    
                                                </td>
                                            </tr>
                                        </tbody>

                                        
                                    </Table>

                              
                                        <h5 className='mt-3 mb-3'>In addition, applicants under External/Part-Time/Internal category have to satisfy the following criteria:</h5>
                                  
                            
                                    <h5 className='mt-3 mb-3'> External:</h5>

                                        <ul className='myulcustarrow'>
                                                <li>The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                                <li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST or by IIT Tirupati.</li>
                                        </ul>

                                    <h5 className='mt-3 mb-3'>Part-Time:</h5>

                                    <ul className='myulcustarrow'>
                                        <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                        <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>
                                    </ul>

                                    <h5 className='mt-3 mb-3'>Internal (IIT Tirupati Staff):</h5>
                                    <ul className='myulcustarrow'>
                                        <li> The applicant must be regular employees of IIT Tirupati.</li>
                                        <li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                    </ul>
                                   
                                </div>
                            </Fade>
                            }
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                           {financialOpen && <Fade in={financialOpen}>
                                <div>
                                    <h4 className='mb-4'>Financial Assistance</h4>
                                    <p>
                                    Financial assistance will be provided as per Ministry of Education (MoE) norms. All full time regular scholars admitted to Ph.D. and M.S (Research) programs are eligible for the Half-time Research Assistantship (HTRA) for which:
                                    </p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                        They should work for 8 hours per week for the Institute to earn this assistantship. The work would normally involve assistance in teaching/research and will be assigned by the Institute.
                                        </li>
                                        <li>
                                        Renewal of assistantship every semester will be contingent on enrolment, satisfactory progress in research work and good performance during the preceding semester in the discharge of responsibility as teaching/ research assistant.
                                        </li>
                                        <li>
                                        Assistantship for candidates who have qualified through UGC-JRF, CSIR-JRF, ICMR & AICTE etc. will be as per the norms of the funding agency.
                                        </li>
                                    </ul>
                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Section*/}

                        <div>
                        {sectionOpen && <Fade in={sectionOpen}>
                                <div>
                                    <h4 className='mb-4'>Selection Procedure</h4>
                                    <p >The selection committee will call eligible candidates based on the minimum eligibility requirements and additional screening criteria for a written test (if any) and interview.</p>
                                </div>
                            </Fade>}
                        </div>


                        {/*Documents*/}

                        <div>
                        {documentsOpen && <Fade in={documentsOpen}>
                                <div>
                                    <h4 className='mb-4'>Original Documents to be submitted for Verification:</h4>
                                    <p>
                                        <b>At the time of Interview and/or Written Test:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of interview and/or written test.</p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                             Copy of application
                                        </li>
                                        <li>
                                        Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                        Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                        Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
                                        </li>
                                        <li>
                                        Copy of GATE score or CSIR-UGC-JRF/LS/NET/DAE-JEST or any other fellowship award.
                                        </li>
                                        <li>
                                        Candidates applying under External Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
                                        </li>

                                        <li>
                                        Candidates applying under Part-Time Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
                                        </li>

                                        <li>
                                            Candidates applying under Internal Category must produce : No Objection Certificate
                                        </li>


                                    </ul>
                                    <p className='text-primary'>
                                    Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                    </p>
                                    <p>
                                        <b>At the time of Admission:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of admission / registration</p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                             Offer of admission.
                                        </li>
                                        <li>
                                             Birth Certificate / SSC / SSLC certifcate as proof of Name and Date of birth
                                        </li>
                                        <li>
                                             Any valid government ID proof such as Aadhaar, PAN, Passport, Driving License, etc.
                                        </li>
                                        <li>
                                             Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                             Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                             Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                             Candidates admitted under External category must also produce:
                                            <ol className='ms-3'>
                                                <li>
                                                No Objection Certificate for using Research Facilities on the employer’s premises. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                Consent of Co-supervisor from the parent organization in case of external candidates. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Co-Supervisor_Particulars.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                
                                            </ol>
                                        </li>

                                        Candidates admitted under Part-Time category must also produce: 
                                        <ol className='ms-3'>
                                            <li>
                                            Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
                                            </li>
                                        </ol>
                                    </ul>
                                    <p className='text-primary'>
                                    Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                    </p>
                                </div>
                            </Fade> }
                        </div>

{/*Section*/}

                        <div>
                            {feesOpen && <Fade in={feesOpen}>
                                <div>
                                    <h4 className='mb-4'>Fees and Deposits</h4>
                                    <p >The applicable tuition and other fee/ deposits for Ph.D. scholars is available at the following <Link to="/fee-structure" className='c-link'>link</Link>.</p>
                                </div>
                            </Fade> }
                        </div>
{/*Apply Online*/}

                        <div>
                            {applyonlineOpen && <Fade in={applyonlineOpen}>
                                <div>
                                    <h4 className='mb-4'>Apply Online</h4>
                                    <p><b>To Apply Online</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/phdapplication" className='c-link'><b>Click Here</b></Link> </p>
                                     {/* <p><b>To login and download application</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/phdapplication.php" target="_blank" className='c-link'><b>Click Here</b></Link>
                                    </p> */}

                                </div>
                            </Fade> }
                        </div>


                    </Col>

                </Row>
            {/* </> */}
            </Container>
        </section>
    );
}

export default Phd_AdmissionELe;
